import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediumEditorWrapper from './MediumEditorWrapper';

export default class EditableTextView extends Component {
  shouldComponentUpdate(nextProps) {
    if (
      !this.props
      || !nextProps.itemId
      || nextProps.itemId !== this.props.itemId
      || this.updateComponent
    ) {
      if (this.updateComponent) this.updateComponent = false;
      return true;
    }
    return false;
  }

  onBlur = (e) => {
    this.props.onBlur && this.props.onBlur(e);
  };

  render() {
    const {
      tag,
      text,
      placeholder,
      wrapperClassName,
      editable,
      editorOptions,
      onChange,
      onKeyDown,
      throttleDuration,
      itemId
    } = this.props;

    const StaticTextComponent = this.props.staticTextComponent || 'div';

    if (editable) {
      return (
        <MediumEditorWrapper
          key={itemId}
          tag={tag || undefined}
          className={wrapperClassName}
          value={text}
          placeholder={placeholder}
          options={editorOptions}
          simpleEditor={true}
          onChange={onChange}
          onBlur={this.onBlur}
          throttleDuration={throttleDuration}
          onKeyDown={onKeyDown || null}
        />
      );
    }

    return (
      <StaticTextComponent
        className={wrapperClassName + ' text-view-custom-container'}
        dangerouslySetInnerHTML={{
          __html: text
        }}
      />
    );
  }
}
// TODO: Sanitize the text passed to check if only valid HTML with allowed is passed.

EditableTextView.propTypes = {
  text: PropTypes.string,
  placeholder: PropTypes.string,
  wrapperClassName: PropTypes.string,
  editable: PropTypes.bool,
  editorOptions: PropTypes.object,
  simpleEditor: PropTypes.bool,
  onChange: PropTypes.func,
  throttleDuration: PropTypes.number,
  onKeyDown: PropTypes.func
};

EditableTextView.defaultProps = {
  text: '',
  placeholder: '',
  wrapperClassName: '',
  editable: false,
  editorOptions: {},
  simpleEditor: true,
  onChange: () => {},
  throttleDuration: 1000,
  onKeyDown: () => {}
};
